<template>
  <div class="pages_su_one">
    <div class="pages_ab">
      <div class="pages_title fx fa_c"> 
          <div class="fs_06 fw_6 pr01">公司简介</div>
          <div class=" fs_03 ls2">COMPANY OVERVIEW</div>
      </div>
      <div class="ab_content">
        <img src="@/assets/summany/wenhua/wh_top.png" class="content_img">
        <div class="cone ">
            <div class="  fx f_j_a f_a_c ml_6 mb05" >
              <img src="@/assets/summany/wenhua/left-line.png" class="cone_img">
              <div class="lh044">
                <div class="fs_044 fw_6">企业价值观</div>
                <div class="fs_022">CORPORATE VALUES</div>
              </div>
              <img src="@/assets/summany/wenhua/left-line.png" class="cone_img tran_180">
            </div>
            <div class="item_one fs_03 ml_4 fx f_j_sb f_a_c tc ml_6 mb05">
              <div class="item_o fw_6 lh12 br_y wow animate__animated animate__fadeInLeft">创新</div>
              <div class="item_o fw_6 lh12 br_y wow animate__animated animate__fadeInLeft">严谨</div>
              <div class="item_o fw_6 lh12 br_y wow animate__animated animate__fadeInLeft">高效</div>
              <div class="item_o fw_6 lh12 br_y wow animate__animated animate__fadeInLeft">开放</div>
              <div class="item_o fw_6 lh12 br_y wow animate__animated animate__fadeInLeft">务实</div>
            </div>
            <div class=" fx f_j_a f_a_c ml_6 mb05" >
              <img src="@/assets/summany/wenhua/left-line.png" class="cone_img">
              <div class="tc lh044">
                <div class="fs_044 fw_6">企业主张</div>
                <div class="fs_022">CORPORATE PROPOSITION</div>
              </div>
              <img src="@/assets/summany/wenhua/left-line.png" class="cone_img tran_180">
            </div>
            <div class="fx ml_6 f_j_sb mb05 wow animate__animated animate__lightSpeedInLeft">
              <div style="width:47%">
                <img src="@/assets/summany/wenhua/img1.png" class="zz_img">
                <div class="fs_03">可持续发展</div>
              </div>
              <div style="width:47%">
                <img src="@/assets/summany/wenhua/img2.png" class="zz_img">
                <div class="fs_03">开放合作共赢</div>
              </div>
            </div>

            <div class=" fx f_j_a f_a_c ml_6 mb05 " >
              <img src="@/assets/summany/wenhua/left-line.png" class="cone_img">
              <div class="tc lh044">
                <div class="fs_044 fw_6">企业使命</div>
                <div class="fs_022">CORPORATE MISSION</div>
              </div>
              <img src="@/assets/summany/wenhua/left-line.png" class="cone_img tran_180">
            </div>

            <div class="fx ml_6 f_j_sb f_a_c mb05 tc">
              <div class="sm_item wow animate__animated animate__lightSpeedInRight">
                <img src="@/assets/summany/wenhua/icon1.png" class="sc_img">
                <div class="fs_03">为股东</div>
                <div class="fs_03">投资创造</div>
                <div class="fs_03">新价值</div>
              </div>
              <div class="sm_item wow animate__animated animate__lightSpeedInRight">
                <img src="@/assets/summany/wenhua/icon2.png" class="sc_img">
                <div class="fs_03">为客户</div>
                <div class="fs_03">服务提供</div>
                <div class="fs_03">新体验</div>
              </div>
              <div class="sm_item wow animate__animated animate__lightSpeedInRight">
                <img src="@/assets/summany/wenhua/icon5.png" class="sc_img">
                <div class="fs_03">为员</div>
                <div class="fs_03">成长搭建</div>
                <div class="fs_03">新平台</div>
              </div>
              <div class="sm_item wow animate__animated animate__lightSpeedInRight">
                <img src="@/assets/summany/wenhua/icon3.png" class="sc_img">
                <div class="fs_03">为社会</div>
                <div class="fs_03">建设赋予</div>
                <div class="fs_03">新动能</div>
              </div>
              <div class="sm_item wow animate__animated animate__lightSpeedInRight">
                <img src="@/assets/summany/wenhua/icon4.png" class="sc_img">
                <div class="fs_03">为行业</div>
                <div class="fs_03">发展引领</div>
                <div class="fs_03">新方向</div>
              </div>
            </div>

        </div>
      </div>

    </div>
   
  </div>
</template>
<script  setup>
import { ref, nextTick, onMounted } from 'vue'
import Wow from "wow.js";
onMounted(() => {

});
</script>
<style  scoped>
.pages_su_one {
  width: 100%;
  height: 100%;
  z-index: 6;
  position: relative;
}
.pages_ab{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
 
}
.pages_title{
  position:absolute;
  top: 4%;
  left: 3%;
  color: #fff;

}


.ab_content{
  position: absolute;
  top: 10%;
  left: 0;
  width: 94%;
  margin: 0 3%;
  height: 86%;
  background-color: #fff;
  border-top-left-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
  overflow-y: auto;
}
.content_img{
  width: 92%;
  height: auto;
  margin: 4% 4%;
}
.cone_img{
  width: 2rem;
  height: auto;
}
.item_o{
  width: 1.2rem;
  height: 1.2rem;
  background-color: #e6eefb;
  color: #0e50da;
  border: 1px solid #71a0e7;
}
.zz_img{
  width: 100%;
}
.sm_item{
  width: 15%;
  padding: 0.1rem;
  border: 1px solid #71a0e7;
  border-radius: 0.1rem;
  background-color: #e6eefb;
  color: #5d5d5f;
}
.sc_img{
  width: 50%;
}

</style>

